<template>
    <TripIcon :icon="icon" />
</template>
<script setup>
import { computed } from 'vue';
import TripIcon from '@/components/trips/icons.vue';

const props = defineProps({
    redemption: {
        type: Object,
        required: true,
    },
});

const icon = computed(() => {
    const { redemption_type } = props.redemption;
    switch (redemption_type.slug) {
        case 'hotel':
            return props.redemption.date_type === 'start'
                ? 'check-in'
                : 'check-out';
        case 'flight':
            return props.redemption.date_type === 'start'
                ? 'flight-depart'
                : 'flight-arrive';
        case 'train':
            return props.redemption.date_type === 'start' ? 'train' : 'train';
        case 'rental-car':
            return props.redemption.date_type === 'start'
                ? 'rental-pickup'
                : 'rental-dropoff';
        case 'other':
            return props.redemption.date_type === 'start' ? 'other' : 'other';
    }
});
</script>
